import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import {
  useResourceRequestAllocationBulkActions,
  useBulkDeleteResourceRequestsFromProject,
  useToggleRemoveRequestDialog,
  useRequestStatusBulkHandlers
} from '../hooks';
import RequestActions from './RequestActions';
import ResourceRequestBulkDeleteActions from './ResourceRequestBulkDeleteActions';

export const BulkResourceRequestsAllocationActions = ({
  project = {},
  resourceRequests
}) => {
  const bulkDeleteResourceRequestsFromProject = useBulkDeleteResourceRequestsFromProject();
  const {
    showRemoveRequestDialog,
    openRemoveRequestDialog,
    closeRemoveRequestDialog
  } = useToggleRemoveRequestDialog();

  const onDeleteResourceRequestsClick = useCallback(() => {
    closeRemoveRequestDialog();
    bulkDeleteResourceRequestsFromProject({ project, resourceRequests });
  }, [
    bulkDeleteResourceRequestsFromProject,
    closeRemoveRequestDialog,
    project,
    resourceRequests
  ]);

  const {
    onAllResourceRequestsSubmit,
    onAllResourceRequestsUnsubmit,
    onAllResourceRequestsAccept,
    onAllResourceRequestsAllocationReject,
    onAllResourceRequestsFulfilledWithoutCache,
    onAllResourceRequestsRejectWithoutCache,
    onAllResourceRequestsRecalledWithoutCache,
    onAllResourceRequestsToBeHiredWithoutCache,
    onAllToBeHiredResourceRequestsToSubmit
  } = useRequestStatusBulkHandlers({ project, resourceRequests });

  const actions = useResourceRequestAllocationBulkActions({
    project,
    resourceRequests,
    onAllResourceRequestsSubmit,
    onAllResourceRequestsUnsubmit,
    openRemoveRequestsDialog: openRemoveRequestDialog,
    onAllResourceRequestsAccept,
    onAllResourceRequestsAllocationReject,
    onAllResourceRequestsFulfilled: onAllResourceRequestsFulfilledWithoutCache,
    onAllResourceRequestsReject: onAllResourceRequestsRejectWithoutCache,
    onAllResourceRequestsRecalled: onAllResourceRequestsRecalledWithoutCache,
    onAllResourceRequestsToBeHired: onAllResourceRequestsToBeHiredWithoutCache,
    onAllToBeHiredResourceRequestsToSubmit
  });

  return (
    <>
      <RequestActions qeIdTag="RequestActions" actions={actions} />
      {showRemoveRequestDialog && (
        <ResourceRequestBulkDeleteActions
          showRemoveRequestsDialog={showRemoveRequestDialog}
          closeRemoveRequestsDialog={closeRemoveRequestDialog}
          onDeleteRequestsClick={onDeleteResourceRequestsClick}
        />
      )}
    </>
  );
};

BulkResourceRequestsAllocationActions.propTypes = {
  resourceRequests: PropTypes.array.isRequired,
  project: PropTypes.object
};

export default BulkResourceRequestsAllocationActions;
